import {Grid, Skeleton, Typography} from "@mui/material"
import {FC} from "react"
import {unescapeHtml} from "../../../helpers"
import "../../../dotcom-articles-style.css"

type Props = {
  textBlocks?: string[]
  loading: boolean
  type?: string
}

const ArticleBody: FC<Props> = (props) => {
  const {textBlocks, loading, type} = props
  return (
    <>
      {loading ? (
        <Grid
          size={12}
          display="flex"
          flexDirection="column"
          alignItems="center"
          rowGap="16px"
        >
          <Grid
            size={12}
            display="flex"
            flexDirection="column"
            alignItems="start"
            rowGap="8px"
            width="100%"
            sx={{
              maxWidth: "800px !important",
            }}
          >
            <Skeleton
              variant="rectangular"
              sx={{
                maxWidth: "800px",
                width: "100%",
                height: "16px",
                backgroundImage:
                  "linear-gradient(to right, #cacdcd 0%, rgba(245, 245, 245, 0) 100%)",
              }}
            />
            <Skeleton
              variant="rectangular"
              sx={{
                maxWidth: "800px",
                width: "100%",
                height: "16px",
                backgroundImage:
                  "linear-gradient(to right, #cacdcd 0%, rgba(245, 245, 245, 0) 100%)",
              }}
            />
            <Skeleton
              variant="rectangular"
              sx={{
                maxWidth: "800px",
                width: "100%",
                height: "16px",
                backgroundImage:
                  "linear-gradient(to right, #cacdcd 0%, rgba(245, 245, 245, 0) 100%)",
              }}
            />
            <Skeleton
              variant="rectangular"
              sx={{
                maxWidth: "800px",
                width: "100%",
                height: "16px",
                backgroundImage:
                  "linear-gradient(to right, #cacdcd 0%, rgba(245, 245, 245, 0) 100%)",
              }}
            />
            <Skeleton
              variant="rectangular"
              sx={{
                maxWidth: "800px",
                width: "100%",
                height: "16px",
                backgroundImage:
                  "linear-gradient(to right, #cacdcd 0%, rgba(245, 245, 245, 0) 100%)",
              }}
            />
            <Skeleton
              variant="rectangular"
              sx={{
                maxWidth: "120px",
                width: "100%",
                height: "16px",
                backgroundImage:
                  "linear-gradient(to right, #cacdcd 0%, rgba(245, 245, 245, 0) 100%)",
              }}
            />
          </Grid>
          <Grid
            size={12}
            display="flex"
            flexDirection="column"
            alignItems="start"
            rowGap="8px"
            width="100%"
            sx={{
              maxWidth: "800px !important",
            }}
          >
            <Skeleton
              variant="rectangular"
              sx={{
                maxWidth: "800px",
                width: "100%",
                height: "16px",
                backgroundImage:
                  "linear-gradient(to right, #cacdcd 0%, rgba(245, 245, 245, 0) 100%)",
              }}
            />
            <Skeleton
              variant="rectangular"
              sx={{
                maxWidth: "800px",
                width: "100%",
                height: "16px",
                backgroundImage:
                  "linear-gradient(to right, #cacdcd 0%, rgba(245, 245, 245, 0) 100%)",
              }}
            />
            <Skeleton
              variant="rectangular"
              sx={{
                maxWidth: "800px",
                width: "100%",
                height: "16px",
                backgroundImage:
                  "linear-gradient(to right, #cacdcd 0%, rgba(245, 245, 245, 0) 100%)",
              }}
            />
            <Skeleton
              variant="rectangular"
              sx={{
                maxWidth: "800px",
                width: "100%",
                height: "16px",
                backgroundImage:
                  "linear-gradient(to right, #cacdcd 0%, rgba(245, 245, 245, 0) 100%)",
              }}
            />
            <Skeleton
              variant="rectangular"
              sx={{
                maxWidth: "800px",
                width: "100%",
                height: "16px",
                backgroundImage:
                  "linear-gradient(to right, #cacdcd 0%, rgba(245, 245, 245, 0) 100%)",
              }}
            />
            <Skeleton
              variant="rectangular"
              sx={{
                maxWidth: "120px",
                width: "100%",
                height: "16px",
                backgroundImage:
                  "linear-gradient(to right, #cacdcd 0%, rgba(245, 245, 245, 0) 100%)",
              }}
            />
          </Grid>
          {type && type == "analysis" && (
            <>
              <Grid
                size={12}
                display="flex"
                flexDirection="column"
                alignItems="start"
                rowGap="8px"
                width="100%"
                sx={{
                  maxWidth: "800px !important",
                }}
              >
                <Skeleton
                  variant="rectangular"
                  sx={{
                    maxWidth: "306px",
                    width: "100%",
                    height: "26px",
                    backgroundImage:
                      "linear-gradient(to right, #cacdcd 0%, rgba(245, 245, 245, 0) 100%)",
                  }}
                />
              </Grid>
              <Grid
                size={12}
                display="flex"
                flexDirection="column"
                alignItems="start"
                rowGap="8px"
                width="100%"
                sx={{
                  maxWidth: "800px !important",
                }}
              >
                <Skeleton
                  variant="rectangular"
                  sx={{
                    maxWidth: "800px",
                    width: "100%",
                    height: "16px",
                    backgroundImage:
                      "linear-gradient(to right, #cacdcd 0%, rgba(245, 245, 245, 0) 100%)",
                  }}
                />
                <Skeleton
                  variant="rectangular"
                  sx={{
                    maxWidth: "800px",
                    width: "100%",
                    height: "16px",
                    backgroundImage:
                      "linear-gradient(to right, #cacdcd 0%, rgba(245, 245, 245, 0) 100%)",
                  }}
                />
                <Skeleton
                  variant="rectangular"
                  sx={{
                    maxWidth: "800px",
                    width: "100%",
                    height: "16px",
                    backgroundImage:
                      "linear-gradient(to right, #cacdcd 0%, rgba(245, 245, 245, 0) 100%)",
                  }}
                />
                <Skeleton
                  variant="rectangular"
                  sx={{
                    maxWidth: "800px",
                    width: "100%",
                    height: "16px",
                    backgroundImage:
                      "linear-gradient(to right, #cacdcd 0%, rgba(245, 245, 245, 0) 100%)",
                  }}
                />
                <Skeleton
                  variant="rectangular"
                  sx={{
                    maxWidth: "800px",
                    width: "100%",
                    height: "16px",
                    backgroundImage:
                      "linear-gradient(to right, #cacdcd 0%, rgba(245, 245, 245, 0) 100%)",
                  }}
                />
                <Skeleton
                  variant="rectangular"
                  sx={{
                    maxWidth: "120px",
                    width: "100%",
                    height: "16px",
                    backgroundImage:
                      "linear-gradient(to right, #cacdcd 0%, rgba(245, 245, 245, 0) 100%)",
                  }}
                />
              </Grid>
              <Grid
                size={12}
                display="flex"
                flexDirection="column"
                alignItems="start"
                rowGap="8px"
                width="100%"
                sx={{
                  maxWidth: "800px !important",
                }}
              >
                <Skeleton
                  variant="rectangular"
                  sx={{
                    maxWidth: "800px",
                    width: "100%",
                    height: "16px",
                    backgroundImage:
                      "linear-gradient(to right, #cacdcd 0%, rgba(245, 245, 245, 0) 100%)",
                  }}
                />
                <Skeleton
                  variant="rectangular"
                  sx={{
                    maxWidth: "800px",
                    width: "100%",
                    height: "16px",
                    backgroundImage:
                      "linear-gradient(to right, #cacdcd 0%, rgba(245, 245, 245, 0) 100%)",
                  }}
                />
                <Skeleton
                  variant="rectangular"
                  sx={{
                    maxWidth: "800px",
                    width: "100%",
                    height: "16px",
                    backgroundImage:
                      "linear-gradient(to right, #cacdcd 0%, rgba(245, 245, 245, 0) 100%)",
                  }}
                />
                <Skeleton
                  variant="rectangular"
                  sx={{
                    maxWidth: "800px",
                    width: "100%",
                    height: "16px",
                    backgroundImage:
                      "linear-gradient(to right, #cacdcd 0%, rgba(245, 245, 245, 0) 100%)",
                  }}
                />
                <Skeleton
                  variant="rectangular"
                  sx={{
                    maxWidth: "800px",
                    width: "100%",
                    height: "16px",
                    backgroundImage:
                      "linear-gradient(to right, #cacdcd 0%, rgba(245, 245, 245, 0) 100%)",
                  }}
                />
                <Skeleton
                  variant="rectangular"
                  sx={{
                    maxWidth: "120px",
                    width: "100%",
                    height: "16px",
                    backgroundImage:
                      "linear-gradient(to right, #cacdcd 0%, rgba(245, 245, 245, 0) 100%)",
                  }}
                />
              </Grid>
            </>
          )}
          {type && type == "podcasts" && (
            <>
              <Grid
                size={12}
                display="flex"
                flexDirection="column"
                alignItems="start"
                rowGap="8px"
                width="100%"
                sx={{
                  maxWidth: "800px !important",
                  paddingX: "94.5px",
                }}
              >
                <Skeleton
                  variant="rectangular"
                  sx={{
                    maxWidth: "611px",
                    width: "100%",
                    height: "187px",
                    backgroundImage:
                      "linear-gradient(to right, #cacdcd 0%, rgba(245, 245, 245, 0) 100%)",
                  }}
                />
              </Grid>
              <Grid
                size={12}
                display="flex"
                flexDirection="column"
                alignItems="start"
                rowGap="8px"
                width="100%"
                sx={{
                  maxWidth: "800px !important",
                  paddingX: "216.5px",
                }}
              >
                <Skeleton
                  variant="rectangular"
                  sx={{
                    maxWidth: "367px",
                    width: "100%",
                    height: "24px",
                    marginBottom: "16px",
                    backgroundImage:
                      "linear-gradient(to right, #cacdcd 0%, rgba(245, 245, 245, 0) 100%)",
                  }}
                />
              </Grid>
              <Grid
                size={12}
                display="flex"
                flexDirection="column"
                alignItems="start"
                rowGap="16px"
                width="100%"
                sx={{
                  maxWidth: "800px !important",
                  paddingX: "175px",
                }}
              >
                <Skeleton
                  variant="rectangular"
                  sx={{
                    maxWidth: "450px",
                    width: "100%",
                    height: "67px",
                    backgroundImage:
                      "linear-gradient(to right, #cacdcd 0%, rgba(245, 245, 245, 0) 100%)",
                  }}
                />
              </Grid>
            </>
          )}
        </Grid>
      ) : (
        <Grid size={12} display="flex" flexDirection="column" alignItems="center">
          {textBlocks &&
            textBlocks.map((textBlock, index) => (
              <Typography
                key={`article-textblock-${index}`}
                component="div"
                variant="body2"
                width="100%"
                maxWidth="800px"
                textAlign="justify"
              >
                <div
                  className="dotcom-article-textblock"
                  dangerouslySetInnerHTML={{__html: unescapeHtml(textBlock)}}
                ></div>
              </Typography>
            ))}
        </Grid>
      )}
    </>
  )
}

export default ArticleBody
